import {
  APPEND_ALBUM_DATA,
  CHANGE_CONTENT_VISIBILITY,
  REMOVE_MEDIA_FROM_ALBUM,
  SET_ALBUM_DATA,
  UPDATE_HABITAT_ALBUM_DATA,
} from './types';

const initialState = {
  total: null,
  list: [],
  type: 'PHOTOS',
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_ALBUM_DATA: {
      const { data } = payload;

      return { ...state, ...data };
    }
    case APPEND_ALBUM_DATA: {
      const { data } = payload;

      return {
        ...state,
        total: data.total,
        list: [...state.list, ...data.list],
      };
    }
    case UPDATE_HABITAT_ALBUM_DATA: {
      const { id, data } = payload;

      return {
        ...state,
        list: state.list.map((media) => (media._id === id ? { ...media, ...data } : media)),
      };
    }
    case CHANGE_CONTENT_VISIBILITY: {
      const { mediaId, action } = payload;
      const disabled = action === 'hide';

      return {
        ...state,
        list: state.list.map((media) => (media._id === mediaId ? { ...media, disabled } : media)),
      };
    }
    case REMOVE_MEDIA_FROM_ALBUM: {
      const { id } = payload;

      return {
        ...state,
        list: state.list.filter((media) => media._id !== id),
      };
    }
    default: {
      return state;
    }
  }
};
